function setEditAttributes (node, name, type) {
  if (node.elm) {
    node.elm.setAttribute('data-epi-property-name', name)
    node.elm.setAttribute('data-epi-use-mvc', 'true')
    node.elm.setAttribute('data-epi-property-render', 'none')
    if (type) {
      node.elm.setAttribute('data-epi-property-edittype', type)
    }
  } else {
    const attrs = node.data.attrs || (node.data.attrs = {})
    attrs['data-epi-property-name'] = name
    attrs['data-epi-use-mvc'] = 'true'
    attrs['data-epi-property-render'] = 'none'
    if (type) {
      attrs['data-epi-property-edittype'] = type
    }
  }
}

function setContentAreaBlockAttributes (node, id) {
  if (node.elm) {
    node.elm.setAttribute('data-epi-block-id', id)
  } else {
    const attrs = node.data.attrs || (node.data.attrs = {})
    attrs['data-epi-block-id'] = id
  }
}

export function edit (node, dir) {
  if (!node.context.$root.editMode) {
    return
  }

  if (dir.arg === 'block') {
    if (!dir.value) {
      console.warn('ContentID missing')
    } else {
      const contentLinkId = dir.value.split('_').pop()
      setContentAreaBlockAttributes(node, contentLinkId)
    }
  } else {
    let type

    if (typeof dir.modifiers === 'object') {
      const mods = Object.getOwnPropertyNames(dir.modifiers)
      if (mods.length) {
        type = mods[0]
      }
    }

    let rawName, editName
    if (typeof dir.value === 'undefined' && typeof dir.expression === 'string') {
      rawName = dir.expression
    } else if (typeof dir.value === 'string' && dir.value !== '') {
      rawName = dir.value
    }

    if (rawName) {
      if (node.context.editPrefix && node.context.editPrefix !== '') {
        editName = `${node.context.editPrefix}.${rawName}`
      } else {
        editName = rawName
      }

      setEditAttributes(node, editName, type)
    }
  }
}
